import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { ITagAbstractClassArgument } from 'tag/ts/tag/interfaces/arguments/ITagAbstractClassArgument';
import { IAssetPlaybackUtility } from 'tag/ts/tag/player/adapters/avia/interfaces/IAssetPlaybackUtility';

/**
 * @copyright © Paramount Streaming
 * @author  Zeeshan Ahmad
 * @description Base class to provide functionality required for asset playback
 */
export abstract class AbstractAssetPlaybackUtility extends AbstractTagClass implements IAssetPlaybackUtility {

	protected constructor( argument: ITagAbstractClassArgument ) {
		super(
			{
				name: 'AbstractAssetPlaybackUtility',
				...argument
			}
		);
	}

	/**
	 * @description Returns media url for playback
	 * @return {string}
	 */
	abstract getMediaUrl(): string;

	/**
	 * @description Returns true if running in INTL region
	 * @return boolean
	 */
	protected isIntl(): boolean {
		return this?.tag?.tagUtilities?.isInternationalContext( this.tag );
	}

	/**
	 * @description Returns true if video ads are enabled
	 * @return boolean
	 */
	protected videoAdsEnabled(): boolean {
		return this?.params?.AD?.VIDEOADS?.enabled === true;
	}
}